import React from "react";
import styles from "./Banner.module.scss";

export default function Banner() {
  return (
    <>
      <div className={styles["banner"]}>
        <h2>Refer & Earn</h2>
        <div className={styles.bgImage} />
      </div>

      <div className={styles.bannerImage}>
        <h3>Our Top Earners</h3>
        <p>Earn 3% for Every Successful Referral!</p>
        <img src="/images/banner.png" alt="" />
      </div>
    </>
  );
}
